export interface ComicChapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  description: string;
  rating: number;
  views: number;
  favorites: number;
  chapters: ComicChapter[];
  updatedAt: string;
  createdAt: string;
  isHot: boolean;
  isNew: boolean;
  type: string;
}

export const categories = [
  { name: '奇幻漫画', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '妖精题材', slug: 'fairy', icon: 'ri-ghost-line' },
  { name: '魔法漫画', slug: 'magic', icon: 'ri-flashlight-line' },
  { name: '韩漫精选', slug: 'korean', icon: 'ri-kakao-talk-line' },
  { name: '日漫经典', slug: 'japanese', icon: 'ri-sun-line' },
  { name: '国漫崛起', slug: 'chinese', icon: 'ri-china-railway-line' },
  { name: '冒险热血', slug: 'adventure', icon: 'ri-rocket-line' },
  { name: '恋爱甜宠', slug: 'romance', icon: 'ri-heart-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '妖精之森的秘密',
    author: '林月如',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20manga%20style%20illustration%20of%20a%20fairy%20girl%20in%20a%20magical%20forest%20with%20glowing%20mushrooms%20and%20sparkles%2C%20soft%20warm%20lighting%2C%20fantasy%20art%2C%20anime%20style%2C%20vibrant%20colors%2C%20detailed%20background%20with%20trees%20and%20magical%20creatures%2C%20clean%20composition%2C%20professional%20illustration&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '奇幻漫画',
    categorySlug: 'fantasy',
    tags: ['奇幻', '妖精', '冒险'],
    status: '连载中',
    description: '在一个被遗忘的古老森林深处，隐藏着妖精的国度。少女小鹿意外闯入这片神秘领域，与妖精王子相遇，展开了一段跨越两个世界的奇幻冒险。森林中的每一片叶子都蕴含着魔法，每一朵花都藏着一个秘密……',
    rating: 9.6,
    views: 1285000,
    favorites: 85600,
    chapters: [
      { id: 101, title: '第120话 最后的约定', number: 120, updatedAt: '2026-08-04' },
      { id: 102, title: '第119话 黑暗深处', number: 119, updatedAt: '2026-08-01' },
      { id: 103, title: '第118话 觉醒之力', number: 118, updatedAt: '2026-07-28' },
    ],
    updatedAt: '2026-08-04',
    createdAt: '2024-03-15',
    isHot: true,
    isNew: false,
    type: '国漫',
  },
  {
    id: 2,
    title: '魔法学院优等生',
    author: '星辰大海',
    coverImage: 'https://readdy.ai/api/search-image?query=Manga%20style%20illustration%20of%20a%20young%20male%20student%20in%20a%20magical%20academy%20uniform%20holding%20a%20glowing%20spell%20book%2C%20gothic%20castle%20background%2C%20warm%20magical%20atmosphere%2C%20anime%20art%20style%2C%20detailed%20character%20design%2C%20soft%20lighting%2C%20professional%20manga%20illustration&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '魔法漫画',
    categorySlug: 'magic',
    tags: ['魔法', '学院', '热血'],
    status: '连载中',
    rating: 9.3,
    views: 956000,
    favorites: 62300,
    chapters: [
      { id: 201, title: '第95话 最终试炼', number: 95, updatedAt: '2026-08-03' },
      { id: 202, title: '第94话 禁术之谜', number: 94, updatedAt: '2026-07-30' },
      { id: 203, title: '第93话 守护之盾', number: 93, updatedAt: '2026-07-26' },
    ],
    updatedAt: '2026-08-03',
    createdAt: '2024-06-20',
    isHot: true,
    isNew: false,
    type: '国漫',
  },
  {
    id: 3,
    title: '月光下的妖精',
    author: '金秀妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20manga%20illustration%20of%20a%20beautiful%20fairy%20under%20moonlight%20with%20translucent%20wings%2C%20silver%20hair%2C%20in%20a%20mystical%20night%20garden%20with%20luminous%20flowers%2C%20Korean%20webtoon%20art%20style%2C%20romantic%20atmosphere%2C%20soft%20blue%20and%20silver%20tones%2C%20vertical%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '妖精题材',
    categorySlug: 'fairy',
    tags: ['妖精', '恋爱', '治愈'],
    status: '连载中',
    rating: 9.7,
    views: 2150000,
    favorites: 128000,
    chapters: [
      { id: 301, 'title': '第88话 月光之约', number: 88, updatedAt: '2026-08-04' },
      { id: 302, 'title': '第87话 银色翅膀', number: 87, updatedAt: '2026-07-31' },
      { id: 303, 'title': '第86话 星空下的吻', number: 86, updatedAt: '2026-07-27' },
    ],
    updatedAt: '2026-08-04',
    createdAt: '2024-01-10',
    isHot: true,
    isNew: false,
    type: '韩漫',
  },
  {
    id: 4,
    title: '异世界转生录',
    author: '山田太郎',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20hero%20with%20a%20sword%20in%20an%20isekai%20fantasy%20world%20with%20dragons%20and%20magic%20circles%2C%20epic%20adventure%20theme%2C%20warm%20color%20palette%2C%20detailed%20armor%20design%2C%20dramatic%20composition%2C%20professional%20anime%20art&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '奇幻漫画',
    categorySlug: 'fantasy',
    tags: ['异世界', '冒险', '热血'],
    status: '连载中',
    rating: 9.4,
    views: 1860000,
    favorites: 94500,
    chapters: [
      { id: 401, 'title': '第156话 魔王降临', number: 156, updatedAt: '2026-08-03' },
      { id: 402, 'title': '第155话 勇者集结', number: 155, updatedAt: '2026-07-29' },
      { id: 403, 'title': '第154话 传说之剑', number: 154, updatedAt: '2026-07-25' },
    ],
    updatedAt: '2026-08-03',
    createdAt: '2023-06-01',
    isHot: true,
    isNew: false,
    type: '日漫',
  },
  {
    id: 5,
    title: '妖精甜品屋',
    author: '樱小路',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20manga%20style%20illustration%20of%20a%20girl%20making%20magical%20desserts%20in%20a%20cozy%20bakery%20with%20tiny%20fairies%20helping%2C%20warm%20pastel%20colors%2C%20charming%20slice%20of%20life%20theme%2C%20anime%20art%20style%2C%20soft%20lighting%2C%20detailed%20food%20illustration&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '恋爱甜宠',
    categorySlug: 'romance',
    tags: ['甜宠', '美食', '治愈'],
    status: '已完结',
    rating: 9.5,
    views: 765000,
    favorites: 45200,
    chapters: [
      { id: 501, 'title': '第60话 甜蜜终章（完）', number: 60, updatedAt: '2026-06-15' },
      { id: 502, 'title': '第59话 告白', number: 59, updatedAt: '2026-06-08' },
      { id: 503, 'title': '第58话 真心', number: 58, updatedAt: '2026-06-01' },
    ],
    updatedAt: '2026-06-15',
    createdAt: '2025-04-01',
    isHot: false,
    isNew: false,
    type: '日漫',
  },
  {
    id: 6,
    title: '剑与魔法纪元',
    author: '刘云飞',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20manga%20illustration%20of%20a%20female%20warrior%20with%20a%20magical%20sword%20in%20a%20medieval%20fantasy%20setting%2C%20dramatic%20lighting%2C%20warm%20golden%20tones%2C%20anime%20art%20style%2C%20detailed%20battle%20armor%2C%20epic%20composition%20with%20magic%20effects&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '冒险热血',
    categorySlug: 'adventure',
    tags: ['冒险', '热血', '战斗'],
    status: '连载中',
    rating: 9.2,
    views: 1120000,
    favorites: 71200,
    chapters: [
      { id: 601, 'title': '第78话 龙骑士团', number: 78, updatedAt: '2026-08-04' },
      { id: 602, 'title': '第77话 远古遗迹', number: 77, updatedAt: '2026-07-31' },
      { id: 603, 'title': '第76话 血之契约', number: 76, updatedAt: '2026-07-27' },
    ],
    updatedAt: '2026-08-04',
    createdAt: '2024-09-10',
    isHot: true,
    isNew: false,
    type: '国漫',
  },
  {
    id: 7,
    title: '妖精医生诊疗所',
    author: '朴智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Heartwarming%20manga%20illustration%20of%20a%20kind%20doctor%20treating%20magical%20creatures%20in%20a%20fantasy%20clinic%2C%20cozy%20atmosphere%2C%20Korean%20webtoon%20style%2C%20warm%20amber%20lighting%2C%20cute%20fairy%20patients%2C%20detailed%20interior%20with%20herbs%20and%20potions&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '妖精题材',
    categorySlug: 'fairy',
    tags: ['妖精', '治愈', '日常'],
    status: '连载中',
    rating: 9.4,
    views: 890000,
    favorites: 56700,
    chapters: [
      { id: 701, 'title': '第42话 龙宝宝的感冒', number: 42, updatedAt: '2026-08-02' },
      { id: 702, 'title': '第41话 凤凰的眼泪', number: 41, updatedAt: '2026-07-28' },
      { id: 703, 'title': '第40话 精灵之森', number: 40, updatedAt: '2026-07-24' },
    ],
    updatedAt: '2026-08-02',
    createdAt: '2025-08-15',
    isHot: false,
    isNew: true,
    type: '韩漫',
  },
  {
    id: 8,
    title: '星辰大海的旅人',
    author: '星野光',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20manga%20illustration%20of%20a%20traveler%20walking%20through%20a%20starry%20cosmic%20landscape%20with%20floating%20islands%2C%20dreamy%20fantasy%20theme%2C%20Japanese%20anime%20art%20style%2C%20ethereal%20warm%20lighting%2C%20flowing%20cape%2C%20adventure%20atmosphere&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '奇幻漫画',
    categorySlug: 'fantasy',
    tags: ['奇幻', '冒险', '科幻'],
    status: '连载中',
    rating: 9.1,
    views: 678000,
    favorites: 38900,
    chapters: [
      { id: 801, 'title': '第34话 黑洞彼端', number: 34, updatedAt: '2026-08-01' },
      { id: 802, 'title': '第33话 时间裂缝', number: 33, updatedAt: '2026-07-27' },
      { id: 803, 'title': '第32话 星之记忆', number: 32, updatedAt: '2026-07-23' },
    ],
    updatedAt: '2026-08-01',
    createdAt: '2025-11-20',
    isHot: false,
    isNew: true,
    type: '日漫',
  },
  {
    id: 9,
    title: '妖精神域',
    author: '陈墨白',
    coverImage: 'https://readdy.ai/api/search-image?query=Atmospheric%20manga%20illustration%20of%20a%20mysterious%20fairy%20realm%20with%20ancient%20ruins%20and%20glowing%20runes%2C%20a%20young%20girl%20in%20traditional%20Chinese%20fantasy%20attire%2C%20Chinese%20manhua%20art%20style%2C%20warm%20golden%20and%20jade%20green%20tones&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '妖精题材',
    categorySlug: 'fairy',
    tags: ['妖精', '仙侠', '奇幻'],
    status: '连载中',
    rating: 9.0,
    views: 534000,
    favorites: 31200,
    chapters: [
      { id: 901, 'title': '第56话 天劫', number: 56, updatedAt: '2026-08-04' },
      { id: 902, 'title': '第55话 灵脉', number: 55, updatedAt: '2026-07-30' },
      { id: 903, 'title': '第54话 秘境', number: 54, updatedAt: '2026-07-26' },
    ],
    updatedAt: '2026-08-04',
    createdAt: '2025-05-10',
    isHot: false,
    isNew: true,
    type: '国漫',
  },
  {
    id: 10,
    title: '魔王与妖精公主',
    author: '尹智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20illustration%20of%20a%20demon%20king%20and%20a%20fairy%20princess%20standing%20together%20in%20a%20contrasting%20light%20and%20dark%20composition%2C%20forbidden%20love%20theme%2C%20Korean%20webtoon%20style%2C%20dramatic%20warm%20lighting%2C%20elegant%20character%20design&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '恋爱甜宠',
    categorySlug: 'romance',
    tags: ['恋爱', '奇幻', '虐心'],
    status: '已完结',
    rating: 9.8,
    views: 2450000,
    favorites: 156000,
    chapters: [
      { id: 1001, 'title': '第72话 永远在一起（完）', number: 72, updatedAt: '2026-07-20' },
      { id: 1002, 'title': '第71话 最后的战斗', number: 71, updatedAt: '2026-07-13' },
      { id: 1003, 'title': '第70话 真相', number: 70, updatedAt: '2026-07-06' },
    ],
    updatedAt: '2026-07-20',
    createdAt: '2024-04-20',
    isHot: true,
    isNew: false,
    type: '韩漫',
  },
  {
    id: 11,
    title: '元素使者传说',
    author: '王一鸣',
    coverImage: 'https://readdy.ai/api/search-image?query=Dynamic%20manga%20illustration%20of%20a%20young%20elemental%20mage%20controlling%20fire%20and%20water%20elements%2C%20action%20pose%2C%20Chinese%20manhua%20style%2C%20vibrant%20warm%20colors%2C%20energy%20effects%2C%20detailed%20magic%20circles%2C%20epic%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '魔法漫画',
    categorySlug: 'magic',
    tags: ['魔法', '战斗', '热血'],
    status: '连载中',
    rating: 9.1,
    views: 723000,
    favorites: 44500,
    chapters: [
      { id: 1101, 'title': '第67话 五元素共鸣', number: 67, updatedAt: '2026-08-03' },
      { id: 1102, 'title': '第66话 风之试炼', number: 66, updatedAt: '2026-07-29' },
      { id: 1103, 'title': '第65话 大地之心', number: 65, updatedAt: '2026-07-25' },
    ],
    updatedAt: '2026-08-03',
    createdAt: '2025-03-01',
    isHot: false,
    isNew: true,
    type: '国漫',
  },
  {
    id: 12,
    title: '被遗忘的妖精国',
    author: '渡边健太',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20manga%20illustration%20of%20a%20hidden%20fairy%20kingdom%20with%20overgrown%20ancient%20architecture%2C%20a%20curious%20girl%20discovering%20the%20entrance%2C%20Japanese%20manga%20style%2C%20warm%20sunlight%20filtering%20through%20trees%2C%20magical%20atmosphere&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '妖精题材',
    categorySlug: 'fairy',
    tags: ['妖精', '冒险', '悬疑'],
    status: '连载中',
    rating: 9.3,
    views: 890000,
    favorites: 52100,
    chapters: [
      { id: 1201, 'title': '第45话 王座的秘密', number: 45, updatedAt: '2026-08-02' },
      { id: 1202, 'title': '第44话 地下迷宫', number: 44, updatedAt: '2026-07-28' },
      { id: 1203, 'title': '第43话 妖精之门', number: 43, updatedAt: '2026-07-24' },
    ],
    updatedAt: '2026-08-02',
    createdAt: '2025-07-05',
    isHot: false,
    isNew: false,
    type: '日漫',
  },
];

export const bannerComics = comics.filter((c) => c.isHot).slice(0, 5);

export const hotComics = comics.filter((c) => c.isHot);

export const newComics = comics.filter((c) => c.isNew);

export const completedComics = comics.filter((c) => c.status === '已完结');

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getRelatedComics(comic: Comic, limit: number = 4): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id && (c.categorySlug === comic.categorySlug || c.tags.some((t) => comic.tags.includes(t))))
    .slice(0, limit);
}

export function searchComics(query: string): Comic[] {
  const q = query.toLowerCase();
  return comics.filter(
    (c) =>
      c.title.toLowerCase().includes(q) ||
      c.author.toLowerCase().includes(q) ||
      c.tags.some((t) => t.toLowerCase().includes(q)) ||
      c.description.toLowerCase().includes(q)
  );
}